if (document.querySelector('[card-carousel-lottie-section]')) {
  var cardCarouselSection = document.querySelector('[card-carousel-lottie-section]');
  var cardCarouselLottiePlayer = cardCarouselSection.querySelector('[card-carousel-lottie]');

  // lottie animation
  // var cardCarouselSectionWasAlreadyInViewport = false;
  var cardCarouselLottieUrl = 'https://cdn.shopify.com/s/files/1/1715/6045/files/1_Rated.lottie?v=1699323697';

  cardCarouselLottiePlayer.load(cardCarouselLottieUrl);
  cardCarouselLottiePlayer.addEventListener('ready', () => {
    cardCarouselLottiePlayer.setSpeed(0.5);
    cardCarouselLottiePlayer.play();
  });
}
